import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { NumInput } from "@/components/shared/NumInput";
import { DOC_KINDS, docKind, applyDocKind, docKindHint } from "@/lib/documents";
import { autoPill } from "@/components/shared/Pill";

// 291: kdo doklad vystavil (přijatá × vydaná, u čerstvého skenu i účtenka) a malý výběr druhu
// dokladu — stejné v okně dokladu i při nahrávání skenu. Druh vyplní čtení faktury, člověk ho
// jen opraví; proto výběr, ne řada tlačítek.
export function DirectionToggle({ issued, onChange, onReceipt, className = "" }) {
  const opts = [["prijata", "Přijatá"], ["vydana", "Vydaná"], ...(onReceipt ? [["uctenka", "Účtenka"]] : [])];
  return (
    <div ref={autoPill} className={`inline-flex max-w-full rounded-full bg-secondary p-1 ${className}`} role="group" aria-label="Kdo doklad vystavil" data-testid="doc-direction">
      {opts.map(([k, l]) => {
        const on = k === (issued ? "vydana" : "prijata");
        return (
          <button key={k} type="button" aria-pressed={on} data-testid={`doc-dir-${k}`}
            onClick={() => (k === "uctenka" ? onReceipt() : !on && onChange(k))}
            className={`h-8 px-3.5 rounded-full text-[13px] font-semibold whitespace-nowrap ${on ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"}`}>{l}</button>
        );
      })}
    </div>
  );
}

export function DocKindRow({ doc, setDoc, className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-1.5 ${className}`}>
      <Select value={docKind(doc)} onValueChange={(k) => setDoc((d) => applyDocKind(d, k))}>
        <SelectTrigger className="h-8 w-auto gap-2 rounded-full px-3.5 text-[13px] font-semibold" aria-label="Druh dokladu" data-testid="doc-kind"><SelectValue /></SelectTrigger>
        <SelectContent>
          {DOC_KINDS.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`doc-kind-${k}`}>{l}</SelectItem>)}
        </SelectContent>
      </Select>
      <span className="text-[13px] text-muted-foreground">{docKindHint(doc)}</span>
    </div>
  );
}

// Konečná faktura od dodavatele, jejíž zálohy v systému nejsou: kolik zbývá zaplatit
// („K úhradě" z faktury). Když jsou zálohy vybrané, doplatek spočítá výběr záloh.
export function AmountDueField({ doc, setDoc, className = "" }) {
  if (!doc || doc.ui_type === "vydana" || doc.is_credit_note || doc.invoice_type !== "konecna") return null;
  if ((doc.advance_ids || []).length) return null;
  return (
    <label className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-sm ${className}`}>
      <span className="text-muted-foreground">K úhradě po zálohách</span>
      <NumInput value={doc.amount_due ?? ""} onChange={(v) => setDoc((d) => ({ ...d, amount_due: v }))} placeholder="celá částka"
        className="h-9 w-40 min-w-0" data-testid="doc-amount-due" />
    </label>
  );
}
